import React from 'react';
import Header4 from '../Common/Header';
import Footer from '../Common/Footer';
import Banner from '../Elements/Banner';
import Services from '../Elements/Services';
var bnrimg = require('../../images/clients.jpg');


class Service1 extends React.Component {
    render() {
        return (
            <>
                <Header4 />
                <div className="page-content">
                    <Banner title="Servicios" pagename="Servicios" description="Conoce los servicios de SoltArc" bgimage={bnrimg}/>
                    <Services/>
                </div>
                <Footer />
            </>
        );
    };
};

export default Service1;